import {FormControl, FormGroup, Validators} from '@angular/forms';
import {RecoverPassword} from '../../model/security/recover-password';
import {PasswordSecurity} from '../../model/security/password-security';
import {UserService} from '../../services/security/user.service';

export class RecoverPasswordForm {

  constructor(private userService: UserService) {

  }

  static getForm(passwordSecurity?: PasswordSecurity): FormGroup {
    const controls = {};
    // @ts-ignore
    controls[RecoverPasswordForm.FIELDS.NEW_PASSWORD] = new FormControl('', [Validators.maxLength(100), Validators.required,
      // @ts-ignore
      Validators.minLength(<number><unknown>passwordSecurity ? passwordSecurity.length : 0)]);
    // @ts-ignore
    controls[RecoverPasswordForm.FIELDS.CONFIRM_PASSWORD] = new FormControl('', [Validators.maxLength(100), Validators.required]);

    return new FormGroup(controls);
  }

  static getValue(recoverPasswordForm?: FormGroup): RecoverPassword {
    const recoverPassword = new RecoverPassword();
    // @ts-ignore
    recoverPassword.newPassword = recoverPasswordForm.get(RecoverPasswordForm.FIELDS.NEW_PASSWORD).value;
    // @ts-ignore
    recoverPassword.confirmPassword = recoverPasswordForm.get(RecoverPasswordForm.FIELDS.CONFIRM_PASSWORD).value;

    return recoverPassword;
  }
}

export module RecoverPasswordForm {
  export enum FIELDS {
    NEW_PASSWORD = 'new_password',
    CONFIRM_PASSWORD = 'confirm_password',
  }
}

